import React, { useEffect, useState } from "react";
import Send from "../../core/communication";
import { LastestAppointmentsDetailsScreen } from "../../screen/LastestAppointmentsDetailsScreen";
import { customToast } from "../../components/Toast";

const LastAppointmentsDetailsContainer = ({ selectedEvent, goBack }) => {
  const [eventDetails, setEventDetails] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = async (url, errorMessage) => {
    setLoading(true);
    try {
      const res = await Send.get(url);
      setEventDetails(res?.data[0]);
    } catch (error) {
      console.error(`Error loading event details: ${error}`);
      customToast(errorMessage, "error");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  };

  const loadDetails = async () => {
    const url = `/events-sector/${selectedEvent.eventId}/${selectedEvent.producerId}/details`;
    await fetchData(url, "Erro ao buscar detalhes do atendimento");
  };

  const loadSheduledDetails = async () => {
    const url = `/events-sector/${selectedEvent.eventId}/sheduled`;
    await fetchData(url, "Erro ao buscar detalhes do agendamento");
  };

  useEffect(() => {
    if (selectedEvent?.eventId && selectedEvent?.assistanceId) {
      loadDetails();
    } else {
      loadSheduledDetails();
    }
  }, [selectedEvent]);

  return <LastestAppointmentsDetailsScreen {...{ eventDetails, goBack, loading }} />;
};

export default LastAppointmentsDetailsContainer;